module.exports = "<div class=\"infopanel col-6 offset-3 text-center\">\n  <p [innerHTML]=\"sanitized\"></p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/infopanel/infopanel.component.html
// module id = ./src/app/infopanel/infopanel.component.html
// module chunks = main